export function isWebviewContext() {
    return document.body.dataset.origin === 'mobileapp';
}

export function mobileAppAuthorizationFailed() {
    return document.body.dataset.mobileAppAuthorizationFailed === 'true';
}

export function getAuthExpirationTimestamp() {
    const expirationDate = document.body.dataset.authExpirationDate;
    return expirationDate ? parseInt(expirationDate, 10) : undefined;
}
